'use client';

import type { Locale } from '@mv/core/model';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { localizedRoutesAtom } from './localizedRoutes.atom';

type Props = Partial<Record<Locale, string>>;

export default function LanguagePickerRoutes({ en, nl, fr }: Props) {
	const setLocalizedRoutes = useSetAtom(localizedRoutesAtom);

	useEffect(() => {
		setLocalizedRoutes({ en, nl, fr });
	}, [setLocalizedRoutes, en, nl, fr]);

	return null;
}
